<script setup lang="ts">
import { defineProps } from "vue";
import { ExternalScore } from "/@src/models/place";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
export interface ModelProps {
    score: ExternalScore;
}

defineProps<ModelProps>();
</script>
<template>
    <a :href="score.link" target="_blank" class="place-tripadvisor">
        <span class="place-tripadvisor-score-star-overlay">
            <span
                class="place-tripadvisor-score-star"
                :style="{
                    width: (score.score / 5) * 100 + '%',
                }"
            ></span>
        </span>
        <span class="place-tripadvisor-number-reviews text-ellipsis">{{
            t("customer.places.tripadvisor.numberOfReviews", {
                numberOfReviews: score.numberOfReviews,
            })
        }}</span>
        <i class="iconify" data-icon="feather:external-link" aria-hidden="true"></i>
    </a>
</template>

<style lang="scss">
.place-tripadvisor {
    display: flex;
    flex-direction: row;
    margin: 2px 0;

    > .place-tripadvisor-score {
        margin-right: 3px;
    }

    > .place-tripadvisor-score-star-overlay {
        margin-top: 3px;
        background: url(data:image/png;base64,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);
        background-size: contain;
        height: 12px;
        width: 69px;

        > .place-tripadvisor-score-star {
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAA9CAMAAADI14SKAAABm1BMVEUAAAAAv38Arm0AqG0AqWsAqWsAqW0Aqm0Aq2wAqWsAqmsApWsAqW4Aq20AqmwAqmwAqmwAqWwAqm0AqmwAqmoAqWwAqWwAqmwAq20AqGoAqWwAqmwArG0A//8AqmwAq2wAqmsAqW0AqWsAq2wAtm0Aqm0AqmwAp2wAq20AqmwAq2sAqmsAq2sAqmwAq24Aq2sAqmwAqGoAqWwAqmwAqnEAqmwAqmwAqmoAq2wAqmsAqmwAq20AqmsAqmwAqmwAqW0AqG0AqmsAqm0ArGsAqWwAqWsAqm0AqmwAqGsAqmwAq2wAqG0AqmwAqmwAqmsAqmwAzGYAqW0As2YAqm0AqlUAq2wAqGsAqm0AqmoAq20AqmwAqmwAqW0Arm4Aq24AqWwAq20AqWsAqmwAq20AqmwArG4AqmsAqmwAqmoAqmwAq2wAqWwAqmwAqWsAq2sAqmwArG8AqmoAqmwAq2wAonQAqWsAqmwAqmwAqm0AqmwArGwAqWwAq20AqmwAqmwAqG0AqWwAqmwAqmwAqWwAqGsArGwAq20AqmwAqWtwHycoAAAAiXRSTlMABC9Sa3yDgXZiRR9BiMj/6a9sISSG4r1eKZ7gbgGH1FFE1poHddI0lPhPolicT4X5NVzUCfOsVFXY0HNd5sZlOMWNK9x3Krtk95Uvv1ff9gWbCp8Gv1iWMLzdeI8sOsdnX+jar1af1wz8oFOlmHnWN0janguM2S2i5SiL5sJjRs3utHEmNHB7Su4LeUQAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAG4SURBVHic1dZVT4MxFIDhg+s4yHB3h+EOY7i7u7u7u/xstt1AKt/XnpAQ3vs+OW3StAD/KQ9PL28fXz//gMAgOhJsCcHvQsPCIwiINTIKuaJjNJXYOB5xF5+goSQmSRRXySmqTGqaAeMsPUOJyTRWnGVlKzA5pgxibp4pk6/AOCswYQrVGMQiQ6ZYlUFbiQFTqswglpVLmYgKDQcLpU6lDoNYJWGq9RiskTi1mg7WCZl6XQYbhE6jtoNNAsauz2CzwHEQHGzhnVaK08Yx7RQGOzink+R0cU43ycEe1umlOX2s009z/FlngOY4GGaQxuAQ4wwTnRHGGf2leaCL5rDnA/E0h7sYYzRnnHUmaM4k6zSRGBvLQAvJmeIcmKY4M7wzS3HmeGeewCzwDECI+Tq2RZGzpM0sJ4ocyNJ1MoUMjGsyK2IGYFXPWZM51gEdZl3G6B31xqbcAYsys2U3YAC2VZ0dQwZgV40pNWEA9lQ2ZTaNq31T5uBQgQE4OjZmTk6VGOejeGagnFcrKq4uLiXKlfiPKu/65pZX7u41FXcPjscfxtPzyytFcVf+1vfuZ4n8WPy0ko2/6QuIxLZnt8sFfQAAAABJRU5ErkJggg==);
            background-size: contain;
            height: 12px;
            margin-right: 0;
            display: block;
        }
    }

    > .place-tripadvisor-number-reviews {
        margin-left: 3px;
        color: var(--dark-text);
    }

    > svg {
        margin-left: 3px;
    }
}
</style>
